module.exports = __webpack_public_path__ + "static/media/subtitle_skill.b9d4a681.svg";